import React from 'react';
import { HeroSection } from '../components/SalesPage/HeroSection';
import { ProblemSection } from '../components/SalesPage/ProblemSection';
import { SolutionSection } from '../components/SalesPage/SolutionSection';
import { BenefitsSection } from '../components/SalesPage/BenefitsSection';
import { PricingSection } from '../components/SalesPage/PricingSection';
import { Footer } from '../components/SalesPage/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-gold/30 selection:text-brand-charcoal-dark" data-id="element-121">
      <HeroSection data-id="element-122" />
      <ProblemSection data-id="element-123" />
      <SolutionSection data-id="element-124" />
      <BenefitsSection data-id="element-125" />
      <PricingSection data-id="element-126" />
      <Footer data-id="element-127" />
    </div>;
}